import React from "react";

export const MinusIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="2"
            fill="none"
        >
            <path
                stroke="#006046"
                strokeLinecap="round"
                strokeWidth="2"
                d="M13 1H1"
            />
        </svg>
    );
};

export const PanIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            fill="none"
        >
            <path
                fill="#006046"
                d="M9.296 2.82a.525.525 0 0 1-.742 0L7.525 1.793v2.583a.525.525 0 1 1-1.05 0V1.792L5.445 2.82a.525.525 0 0 1-.741-.742L6.629.154a.525.525 0 0 1 .742 0l1.925 1.925a.525.525 0 0 1 0 .742ZM2.821 8.555a.525.525 0 1 1-.742.742L.154 7.371a.525.525 0 0 1 0-.742l1.925-1.925a.525.525 0 0 1 .742.742L1.79 6.475h2.584a.525.525 0 1 1 0 1.05H1.792l1.029 1.03Zm8.358.742a.525.525 0 0 1 0-.742l1.03-1.029H9.624a.525.525 0 1 1 0-1.05h2.583l-1.029-1.03a.525.525 0 0 1 .742-.741l1.926 1.925a.525.525 0 0 1 0 .742L11.92 9.296a.525.525 0 0 1-.742 0ZM9.296 11.18a.525.525 0 0 0-.742 0l-1.029 1.03V9.624a.525.525 0 1 0-1.05 0v2.583l-1.03-1.029a.525.525 0 0 0-.741.742l1.925 1.926a.525.525 0 0 0 .742 0l1.925-1.926a.525.525 0 0 0 0-.742Z"
            />
        </svg>
    );
};

export const PlusIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            fill="none"
        >
            <path
                stroke="#006046"
                strokeLinecap="round"
                strokeWidth="2"
                d="M7 13V7m0 0V1m0 6h6M7 7H1"
            />
        </svg>
    );
};

export const RulerIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="15"
            fill="none"
        >
            <path
                fill="#006046"
                d="M.371 7.815A.759.759 0 0 0 .1 8.841l3.302 5.783a.749.749 0 0 0 .45.35.735.735 0 0 0 .565-.075l13.213-7.714a.745.745 0 0 0 .346-.456.76.76 0 0 0-.075-.57L14.6.375a.749.749 0 0 0-.452-.35.735.735 0 0 0-.564.075L.371 7.815Zm1.386.926 11.927-6.964 2.558 4.482-.86.502-.958-1.68-.643.376.959 1.68-.984.574-.96-1.68-.642.376.959 1.68-.983.573-.96-1.68-.642.376.959 1.68-.984.574L9.17 7.276l-.643.376L9.86 9.986l-.984.574-.96-1.68-.643.376.96 1.68-.983.573-.959-1.68-.643.376.958 1.68-.983.575-.96-1.68-.643.375.96 1.68-.664.388L1.757 8.74Z"
            />
        </svg>
    );
};

export const LocationIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="none"
        >
            <path
                fill="#006046"
                fillRule="evenodd"
                d="M8.003.89a.89.89 0 1 1 1.778 0v1.744c2.797.397 5.009 2.636 5.4 5.466h1.703a.9.9 0 0 1 0 1.8h-1.702c-.392 2.83-2.604 5.07-5.4 5.466v1.745a.89.89 0 1 1-1.78 0v-1.745c-2.796-.396-5.008-2.636-5.4-5.466H.9a.9.9 0 1 1 0-1.8h1.702c.392-2.83 2.605-5.07 5.401-5.466V.889Zm.89 12.702c2.505 0 4.536-2.056 4.536-4.592 0-2.536-2.031-4.592-4.537-4.592-2.505 0-4.537 2.056-4.537 4.592 0 2.536 2.032 4.592 4.537 4.592Z"
                clipRule="evenodd"
            />
        </svg>
    );
};

export const DofOsmIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="29"
            fill="none"
        >
            <path
                fill="#006046"
                d="M4.375 11H1.233V.818h3.281c.988 0 1.833.204 2.536.612a4.003 4.003 0 0 1 1.615 1.745c.375.755.562 1.66.562 2.714 0 1.06-.189 1.974-.566 2.74a4.038 4.038 0 0 1-1.651 1.76c-.723.407-1.6.611-2.635.611Zm-1.91-1.094h1.83c.842 0 1.54-.162 2.093-.487a3.003 3.003 0 0 0 1.238-1.387c.272-.6.408-1.314.408-2.143 0-.822-.134-1.53-.403-2.123a2.97 2.97 0 0 0-1.203-1.372c-.533-.321-1.198-.482-1.993-.482h-1.97v7.994ZM19.887 5.91c0 1.074-.194 2.002-.581 2.784-.388.782-.92 1.386-1.596 1.81-.676.424-1.449.636-2.317.636-.868 0-1.64-.212-2.317-.636-.676-.424-1.208-1.028-1.596-1.81-.387-.782-.581-1.71-.581-2.784 0-1.074.194-2.002.581-2.784.388-.782.92-1.385 1.596-1.81.676-.424 1.449-.636 2.317-.636.868 0 1.64.212 2.317.636.676.425 1.208 1.028 1.596 1.81.387.782.581 1.71.581 2.784Zm-1.193 0c0-.882-.147-1.626-.442-2.232-.292-.607-.688-1.066-1.189-1.377a3.081 3.081 0 0 0-1.67-.468c-.616 0-1.175.156-1.675.468-.498.311-.894.77-1.189 1.377-.291.606-.437 1.35-.437 2.232 0 .882.146 1.626.437 2.232.295.607.691 1.066 1.189 1.377.5.312 1.059.468 1.675.468.617 0 1.173-.156 1.67-.468.501-.311.897-.77 1.189-1.377.295-.606.442-1.35.442-2.232ZM21.96 11V.818h6.106v1.094h-4.873v3.44h4.415v1.094h-4.415V11H21.96ZM9.824 22.91c0 1.073-.194 2.001-.582 2.783-.388.782-.92 1.386-1.596 1.81-.676.424-1.448.636-2.316.636-.869 0-1.641-.212-2.317-.636-.676-.424-1.208-1.028-1.596-1.81-.388-.782-.582-1.71-.582-2.784 0-1.074.194-2.002.582-2.784.388-.782.92-1.385 1.596-1.81.676-.424 1.448-.636 2.317-.636.868 0 1.64.212 2.316.636.676.425 1.208 1.028 1.596 1.81.388.782.582 1.71.582 2.784Zm-1.193 0c0-.883-.148-1.627-.443-2.233C7.897 20.07 7.5 19.61 7 19.3a3.081 3.081 0 0 0-1.67-.468c-.617 0-1.175.156-1.676.468-.497.311-.893.77-1.188 1.377-.292.606-.438 1.35-.438 2.232 0 .882.146 1.626.438 2.232.295.607.691 1.066 1.188 1.378.5.311 1.06.467 1.676.467.616 0 1.173-.156 1.67-.468.5-.311.897-.77 1.188-1.377.295-.606.443-1.35.443-2.232Zm8.834-2.546a1.56 1.56 0 0 0-.726-1.174c-.424-.278-.944-.417-1.56-.417-.452 0-.846.073-1.184.218a1.89 1.89 0 0 0-.785.602 1.442 1.442 0 0 0-.279.87c0 .272.065.505.194.701.133.192.302.353.507.482.206.126.421.23.646.313.226.08.433.145.622.194l1.034.279c.265.07.56.166.885.288.328.123.641.29.94.502.301.21.55.478.745.806.196.328.294.73.294 1.208a2.68 2.68 0 0 1-.433 1.491c-.285.444-.703.797-1.253 1.06-.547.261-1.211.392-1.993.392-.73 0-1.361-.118-1.895-.353-.53-.235-.947-.564-1.252-.984a2.809 2.809 0 0 1-.512-1.467h1.272c.033.384.163.703.388.954.229.25.517.435.865.557.351.12.73.18 1.134.18.47 0 .893-.077 1.267-.23.375-.155.672-.37.89-.646.219-.278.328-.603.328-.974 0-.338-.094-.613-.283-.825a2.08 2.08 0 0 0-.746-.517 7.834 7.834 0 0 0-.999-.348l-1.253-.358c-.795-.23-1.425-.555-1.89-.98-.463-.424-.695-.98-.695-1.665 0-.57.154-1.067.462-1.492.312-.427.73-.759 1.253-.994a4.231 4.231 0 0 1 1.765-.358c.656 0 1.24.118 1.75.353.51.232.915.55 1.213.954.302.405.46.864.477 1.378h-1.193Zm3.36-2.546h1.471l3.46 8.452h.12l3.46-8.452h1.472V28h-1.154v-7.736h-.1L26.374 28h-1.114l-3.181-7.736h-.1V28h-1.153V17.818Z"
            />
        </svg>
    );
};

export const Icon3D = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="13"
            fill="none"
        >
            <path
                fill="#006046"
                d="M4.136 12.16c-.75 0-1.418-.13-2.005-.387-.584-.258-1.048-.616-1.392-1.074A2.887 2.887 0 0 1 .182 9.09h1.432c.03.375.159.699.386.972.227.268.525.477.892.624.367.148.775.222 1.222.222.5 0 .943-.087 1.33-.261.386-.175.689-.417.908-.728.22-.31.33-.67.33-1.08 0-.427-.106-.804-.318-1.13-.212-.33-.523-.587-.932-.772-.41-.186-.91-.279-1.5-.279H3V5.41h.932c.462 0 .867-.083 1.216-.25.352-.167.627-.401.824-.704.2-.303.3-.66.3-1.069 0-.394-.086-.736-.26-1.028a1.788 1.788 0 0 0-.74-.682c-.314-.163-.685-.244-1.113-.244-.401 0-.78.074-1.136.221-.353.144-.64.355-.864.631a1.642 1.642 0 0 0-.364.989H.432c.023-.61.206-1.144.551-1.603A3.47 3.47 0 0 1 2.335.59 4.37 4.37 0 0 1 4.182.206c.72 0 1.337.145 1.852.437a3.08 3.08 0 0 1 1.188 1.142c.276.474.414.985.414 1.534 0 .655-.172 1.214-.517 1.676-.34.462-.805.783-1.392.96v.091c.735.122 1.309.434 1.722.938.413.5.62 1.12.62 1.858 0 .632-.173 1.2-.518 1.705-.34.5-.807.893-1.398 1.181-.59.288-1.263.432-2.017.432ZM14.188 12h-3.591V.364h3.75c1.128 0 2.094.233 2.897.699.803.462 1.419 1.126 1.847 1.994.428.863.642 1.898.642 3.102 0 1.212-.216 2.256-.648 3.13a4.615 4.615 0 0 1-1.886 2.012c-.826.466-1.83.699-3.012.699Zm-2.182-1.25h2.09c.963 0 1.76-.186 2.393-.557a3.432 3.432 0 0 0 1.414-1.585c.311-.686.466-1.502.466-2.449 0-.94-.153-1.748-.46-2.426a3.395 3.395 0 0 0-1.375-1.568c-.61-.368-1.37-.551-2.278-.551h-2.25v9.136Z"
            />
        </svg>
    );
};

export const CompareIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="none"
        >
            <path
                fill="#006046"
                d="M7.5 3H3.75c-.825 0-1.5.675-1.5 1.5v9c0 .825.675 1.5 1.5 1.5H7.5v3H9V0H7.5v3Zm6.75 0H10.5v1.5h3.75v9H10.5V15h3.75c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5Z"
            />
        </svg>
    );
};
